import { ref } from 'vue';
import { apiLink } from './apiLink'
import { deleteData, getData, postData, putData, getBlob , getVideo} from './generalio';
//import { get } from 'core-js/core/dict';
const projectData = () => {
    const hostRoot = ref(apiLink)
    //const categories = ref([]) // if you just return the stuff - then its clearer - its a Promise thats returned

    const getGeoJson = (clientId) => {
        //console.log("THIBWQ")
        let endpoint = `project/${clientId}/geojson`
        return getData(endpoint, "geojson", [])
            .catch(err => {
                let msg = `ERROR fn: getproject: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const clearProjectCalculationDetails = (clientId,projectId) => {
        let endpoint = `project/${clientId}/${projectId}/clearCalcDetails`
        return getData(endpoint, "clearCalcDetails", [])
            .catch(err => {
                let msg = `ERROR fn: clearCalcDetails: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }
   
    const getPLC = (clientId) => {
        let endpoint = `project/projectslocationsyears/${clientId}`
        return getData(endpoint, "getPLC", [])
            .catch(err => {
                let msg = `ERROR fn: getproject: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }
    const getFiles = (clientId, projectId) => {
        let endpoint = `project/${clientId}/${projectId}/files`
        return getData(endpoint, "files", [])
            .catch(err => {
                let msg = `ERROR fn: getfiles: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const viewFile = (clientId, projectId, file, folder) => {
        let endpoint = `project/${clientId}/${projectId}/files/view?filename=${encodeURIComponent(file)}`

        if (folder) {
            endpoint += `&folder=${encodeURIComponent(folder)}`;
        }
        return getBlob(endpoint, "files", [])
            .catch(err => {
                let msg = `ERROR fn: viewfile: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const zipFiles = (clientId, projectId, files) => {
        let endpoint = `project/${clientId}/${projectId}/files/zip`
        return postData(endpoint, files, "files", [], true)
            .catch(err => {
                let msg = `ERROR fn: zipfiles: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }
    
    const getVideos = (filename) => {
        let endpoint = `project/media/stream/${filename}`
        return getVideo(endpoint, "files", [])
            .catch(err => {
                let msg = `ERROR fn: getfiles: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const getProject = (projectId) => {
        let endpoint = `project/${projectId}`
        return getData(endpoint, "project", [])
            .catch(err => {
                let msg = `ERROR fn: getProject: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const getProjectsFromClient = (clientId) => {
        let endpoint = `project/${clientId}/projlistreverse`
        return getData(endpoint, "project", [])
            .catch(err => {
                let msg = `ERROR fn: getProjectsFromClient: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const importProject = (file) => {
        let endpoint = `import/bundle`
        return postData(endpoint, file, "import", [], false, true)
            .catch(err => {
                let msg = `ERROR fn: importProject: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const deleteProject = (projectId) => {
        let endpoint = `project/${projectId}`
        return deleteData(endpoint, "project", [])
            .catch(err => {
                let msg = `ERROR fn: deleteProject: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const getClients = (sort) => {
        let endpoint = `project/cids/${sort}`
        return getData(endpoint, "project", [])
            .catch(err => {
                let msg = `ERROR fn: getClients: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const getClientsForUser = (id) => {
        let endpoint = `project/cids/${id}/user`
        return getData(endpoint, "project", [])
            .catch(err => {
                let msg = `ERROR fn: getClientsForUser: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }
    const getRelatedProjects = (projectId) => {
        let endpoint = `project/relatedprojects/${projectId}`
        return getData(endpoint, "project", [])
            .catch(err => {
                let msg = `ERROR fn: getRelatedProjects: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const createLink = (id1, id2) => {
        let endpoint = `project/link/${id1}/${id2}`
        return putData(endpoint, null, "project", [])
            .catch(err => {
                let msg = `ERROR fn: createLink: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }

    const deleteLinks = (projectId) => {
        let endpoint = `project/link/${projectId}`
        return deleteData(endpoint, null, "project", [])
            .catch(err => {
                let msg = `ERROR fn: createLink: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }
    
    return { clearProjectCalculationDetails, getGeoJson, getFiles, viewFile, zipFiles , getVideos, getPLC, getProject, getProjectsFromClient, importProject, deleteProject, getClients, getRelatedProjects, createLink, getClientsForUser, deleteLinks}
}

export default (projectData)
